"use client";

import { createContext, type ReactNode, useContext } from "react";
import type { ArtistRuntimeConfiguration } from "@/domain/auth/AuthProviderConfiguration";

const ArtistRuntimeConfigurationContext = createContext<ArtistRuntimeConfiguration | null>(null);

export function ArtistRuntimeConfigurationProvider({
	children,
	value,
}: Readonly<{ children: ReactNode; value: ArtistRuntimeConfiguration }>) {
	return (
		<ArtistRuntimeConfigurationContext.Provider value={value}>
			{children}
		</ArtistRuntimeConfigurationContext.Provider>
	);
}

export function useArtistRuntimeConfiguration(): ArtistRuntimeConfiguration {
	const value = useContext(ArtistRuntimeConfigurationContext);
	if (value === null) {
		throw new Error("Artist runtime configuration was not injected at application startup");
	}
	return value;
}
